import React, { useEffect, useState, useContext, useRef } from "react";
import PropTypes from "prop-types";
import { Form, Formik, Field, useFormikContext } from "formik";
import useSoundCloud from "../../hooks/useSoundCloud";
import ComboBox from "../common/ComboBox";

const SelectMusic = ({ defaultMusic, onChange }) => {
  let iframeRef = useRef(null);
  const widgetRef = useRef(null);
  const [musicList, setMusicList] = useState([]);
  const [currentMusic, setCurrentMusic] = useState(undefined);
  const { searchTracks } = useSoundCloud();
  const [defaultLink] = useState(defaultMusic ?? "");
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    initMusic();

    return () => {
      if (widgetRef.current) {
        try {
          widgetRef.current.unbind(window.SC.Widget.Events.READY);
          widgetRef.current.unbind(window.SC.Widget.Events.PLAY);
          widgetRef.current.unbind(window.SC.Widget.Events.PAUSE);
          widgetRef.current.unbind(window.SC.Widget.Events.FINISH);
        } catch (error) {
          console.error(error);
        }
      }
    };
  }, []);

  useEffect(() => {
    onChange(currentMusic);

    if (!currentMusic) {
      setIsPlaying(false);
    }
  }, [currentMusic]);

  useEffect(() => {
    console.log("default", defaultMusic);

    return () => {};
  }, [defaultMusic]);

  const initMusic = async () => {
    const musics = await searchTracks();

    if (musics.length === 0) return;

    const _musics = musics.map((m) => ({
      value: m.permalink_url,
      name: m.title,
      icon: m.artwork_url,
    }));

    setMusicList(_musics);
  };

  const handleSearch = async (value) => {
    const musics = await searchTracks(value);

    setMusicList(
      musics.map((m) => ({
        value: m.permalink_url,
        name: m.title,
        icon: m.artwork_url,
      }))
    );
  };

  const handleChange = (value) => {
    if (!value || !value.music) {
      setCurrentMusic(null);

      if (widgetRef.current) {
        widgetRef.current.pause();
      }

      return;
    }

    const _newLink = `${value.music?.replace(
      "https://soundcloud.com",
      "https%3A//soundcloud.com"
    )}`;

    if (widgetRef.current) {
      widgetRef.current.setVolume(50);
      widgetRef.current.load(_newLink, {
        auto_play: true,
        color: "ff5500",
        show_comments: false,
        hide_related: true,
        show_user: true,
        show_reposts: false,
      });
    }

    setCurrentMusic(_newLink);
  };

  const ref = React.useCallback((node) => {
    if (!node) return;

    widgetRef.current = window.SC.Widget(node);

    widgetRef.current.bind(window.SC.Widget.Events.READY, () => {
      console.log("SoundCloud widget ready!");

      if (!currentMusic) return;

      widgetRef.current.play();
    });

    widgetRef.current.bind(window.SC.Widget.Events.PLAY, () => {
      setIsPlaying(true);
    });

    widgetRef.current.bind(window.SC.Widget.Events.PAUSE, () => {
      console.log("SoundCloud widget is paused");
    });

    widgetRef.current.bind(window.SC.Widget.Events.FINISH, () => {
      console.log("SoundCloud widget is finished");

      widgetRef.current.seekTo(0);
      widgetRef.current.play();
    });
  }, []);

  return (
    <div className="new-project-hotspot-music">
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Formik initialValues={{ music: currentMusic }} validate={handleChange}>
          <Form style={{ flex: 1 }}>
            {musicList.length > 0 && (
              <ComboBox
                name="music"
                options={musicList ?? []}
                canClear={true}
                onSearch={handleSearch}
              />
            )}
          </Form>
        </Formik>
      </div>
      {/* {currentMusic && ( */}
      <div
        className={[
          "new-project-hotspot-music-soundcloud",
          !isPlaying ? "new-project-hotspot-music-soundcloud--hidden" : "",
        ].join(" ")}
      >
        <iframe
          ref={ref}
          id="soundcloud-widget"
          width="100%"
          height="166"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src={`https://w.soundcloud.com/player/?url=${
            defaultLink ?? ""
          }&amp;color=ff5500&amp;auto_play=true&amp;hide_related=true&amp;show_comments=false&amp;show_user=true&amp;show_reposts=false`}
        ></iframe>
      </div>
      {/* )} */}
    </div>
  );
};

SelectMusic.propTypes = {
  onChange: PropTypes.func,
};

SelectMusic.defaultProps = {
  onChange: () => {},
};

export default SelectMusic;
